export const REGIME_STATES = [
    { id: "draft", label: "Draft" },
    { id: "review", label: "Review" },
    { id: "candidate", label: "Candidate" },
    { id: "live", label: "Live" },
]

export function getRegimeStates(item) {
    const { hasReview, hasReady, hasLive } = item?.$ ?? {}
    const states = []
    if (hasReview) states.push("review")
    if (hasReady) states.push("candidate")
    if (hasLive) states.push("live")
    if (!states.length) states.push("draft")
    return states
}
